import { render, staticRenderFns } from "./PreviewLiveSwitch.vue?vue&type=template&id=59a3041e"
import script from "./PreviewLiveSwitch.vue?vue&type=script&lang=js"
export * from "./PreviewLiveSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports